import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import { Button } from '../StyledComponents';

const roleOptions = [
  'Head Coach',
  'Assistant Coach',
  'Owner/Manager',
  'Team Mom',
  'Player',
  'Other',
];

const boaEventOptions = [
  'Memorial Day Classic',
  'Summer Kick Off',
  'Gold Glove Classic',
  "Father's Day Classic",
  'Hometown Heroes',
  'Star Spangled Shootout',
  'Kapau Klassic',
  'Mid-Summer Showdown',
  'Blitzball Bash',
  'Global Games',
];

const boaAgeGroupOptions = ['11U', '12U', '13U', '14U', '15U', '16U'];

const greekRoleOptions = [
  'President',
  'Vice President',
  'Secretary',
  'Treasurer',
  'Alumni Secretary',
  'Social Chair',
  'Rush Chair',
  'Member',
  'Other',
];

const Form = ({
  nextStep,
  formData,
  errors,
  handleChange,
  triggerValidation,
  envParam,
  variant
}) => {
  const handleNext = () => {
    const validationResult = triggerValidation();
    if (
      Object.keys(errors).length === 0 &&
      Object.keys(validationResult).length === 0
    ) {
      nextStep();
    }
  };

  const readyForNext = () => {
    if (
      !formData.firstName ||
      !formData.lastName ||
      !formData.email ||
      !formData.phone ||
      !formData.role ||
      !formData.teamName ||
      (variant !== 'boa' && !formData.numOrders) ||
      (variant === 'boa' && (!formData.event || !formData.ageGroup)) ||
      Object.keys(errors).length !== 0
    ) {
      return false;
    }

    return true;
  };

  const handleDataChange = e => {
    const { name, value } = e.target;

    if (name === 'phone') {
      var x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      handleChange({
        phone: !x[2]
          ? x[1]
          : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : ''),
      });
    } else {
      handleChange({ [name]: value });
    }

    if (errors[name]) {
      triggerValidation();
    }
  };

  const searchParams = new URLSearchParams(window.location.search);
  const sport = searchParams.get('sport');
  const isGreek = envParam === 'greekjerseys.com' || sport === 'greek';

  return (
    <StyledFormStep
      key="initial-form"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.25 }}
    >
      {variant === 'boa' ? (
        <h2>Request Your New Designs</h2>
      ) : (
        <h2>Request your free {sport === 'apparel' ? 'apparel' : 'uniform'} designs</h2>
      )}
      <div className="form">
        <div className="form-control half">
          {formData.source && (
            <input type="hidden" name="source" value={formData.source} />
          )}
          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            onChange={handleDataChange}
            value={formData.firstName}
            className={`${errors.firstName && 'error'}`}
            required
          />
          {errors.firstName && <p className="error">{errors.firstName}</p>}
        </div>
        <div className="form-control half">
          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            onChange={handleDataChange}
            value={formData.lastName}
            className={`${errors.lastName && 'error'}`}
            required
          />
          {errors.lastName && <p className="error">{errors.lastName}</p>}
        </div>
        <div className="form-control">
          <input
            type="email"
            name="email"
            placeholder="Email"
            onChange={handleDataChange}
            value={formData.email}
            className={`${errors.email && 'error'}`}
            required
          />
          {errors.email && <p className="error">{errors.email}</p>}
        </div>
        <div className="form-control half">
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            onChange={handleDataChange}
            value={formData.phone}
            className={`${errors.phone && 'error'}`}
            required
          />
          {errors.phone && <p className="error">{errors.phone}</p>}
        </div>
        <div className="form-control custom-select half">
          <select
            name="role"
            id="role"
            value={formData.role}
            onChange={handleDataChange}
            className={`${errors.role && 'error'}`}
            required
          >
            <option value="">
              What is your role{' '}
              {isGreek ? 'within the organization' : 'on the team'}?
            </option>
            {!isGreek
              ? roleOptions.map((role, index) => (
                  <option
                    key={index}
                    value={role}
                    className={`${formData.role === role && 'selected'}`}
                  >
                    {role}
                  </option>
                ))
              : greekRoleOptions.map((role, index) => (
                  <option
                    key={index}
                    value={role}
                    className={`${formData.role === role && 'selected'}`}
                  >
                    {role}
                  </option>
                ))}
          </select>
          {errors.role && <p className="error">{errors.role}</p>}
        </div>
        <div className="form-control">
          <input
            type="text"
            name="teamName"
            placeholder="Team/Club Name"
            onChange={handleDataChange}
            value={formData.teamName}
            className={`${errors.teamName && 'error'}`}
            required
          />
          {errors.teamName && <p className="error">{errors.teamName}</p>}
        </div>
        {variant === 'boa' && (
          <>
            <div className="form-control custom-select half">
              <select
                name="event"
                id="event"
                value={formData.event}
                onChange={handleDataChange}
                required
              >
                <option value="">Which event are you attending?</option>
                {boaEventOptions.map(option => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-control custom-select half">
              <select
                name="ageGroup"
                id="ageGroup"
                value={formData.ageGroup}
                onChange={handleDataChange}
                required
              >
                <option value="">What is your age group?</option>
                {boaAgeGroupOptions.map(option => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          </>
        )}
        {variant !== 'boa' && (
        <div className="form-control custom-select full-width">
          <select
            name="numOrders"
            id="numOrders"
            value={formData.numOrders}
            onChange={handleDataChange}
            className={`${errors.numOrders && 'error'}`}
            required
          >
            <option value="">
              How many jerseys/garments do you plan to order?
            </option>
            <option value="Bulk">
              Bulk order for my {isGreek ? 'organization (9+ jerseys)' : 'team'}
            </option>
            <option value="One for myself">One for myself</option>
          </select>
            {errors.role && <p className="error">{errors.role}</p>}
          </div>
        )}
      </div>
      <Button
        className="next-step-btn"
        onClick={handleNext}
        disabled={!readyForNext()}
      >
        Next Step
      </Button>
    </StyledFormStep>
  );
};

const StyledFormStep = styled(motion.div)`
  padding: 50px 20px 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  h2 {
    margin-top: 0;
    text-transform: uppercase;
    font-weight: bold;
    text-align: center;
  }

  .form {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0 auto;
    width: 100%;
    max-width: 840px;
    gap: 40px;
    padding: 40px;

    .form-control {
      width: 100%;

      &.full-width {
        max-width: unset;
        padding: 0.8rem;
      }

      input {
        width: 100%;
        height: 100%;
        padding: 0.75rem;
        background-color: #b4b4b4 !important;
        color: #fff;
        border: 1px solid #b4b4b4;
        border-radius: 5px;
        font-size: 20px;

        &::placeholder {
          color: #fff;
          opacity: 0.7;
          text-transform: uppercase;
        }

        &.error {
          border-color: var(--red);
        }
      }

      p.error {
        color: var(--red);
        font-size: 12px;
        margin-top: 5px;
        position: absolute;
      }

      &.half {
        max-width: calc(50% - 20px);

        @media (max-width: 640px) {
          max-width: 100%;
        }
      }
    }

    @media (max-width: 768px) {
      padding: 20px;
    }
  }

  button {
    margin: auto;
  }
`;

export default Form;
